export enum ErrorsCode {
  AllTheUserNotHavePermissions = '02',
  SomeOneUserNotHavePermissions = '01',
  AllUsersHavePermissions = '00',
}

export enum FrecuencyTypeTextResponse {
  UNIQUE = 'UNIQUE',
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  CYCLICAL = 'CYCLICAL'
}

export enum TypeDeleteSchedule {
  UNIQUE = 1,
  SERIE = 2,
  MASIVE = 3,
}
